import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReceivedRunModal from '../../../components/ReceivedRun/ReceivedRunModal';
import ReceivedRunDetails from '../../../components/ReceivedRun/ReveivedRunDetails';
import { abnormalityTypeCanHaveReceivedRun } from '../../../shared/utils/abnormalityHelpers';

class ReceivedRun extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    handleOpenRunModal = () => {
        this.setState(() => ({
            showModal: true,
        }));
    };

    handleCloseRunModal = () => {
        this.setState(() => ({
            showModal: false,
        }));
    };

    handleConfirmRunModal = run => {
        this.props.onChooseReceivedRun(run);
        this.setState(() => ({
            showModal: false,
        }));
    };

    render() {
        let { showModal } = this.state;
        let { receivedRun, onRemoveReceivedRun } = this.props;

        return (
            <div>
                <ReceivedRunDetails
                    receivedRun={receivedRun}
                    openModal={this.handleOpenRunModal}
                    isApplicable={abnormalityTypeCanHaveReceivedRun(this.props.abnormalityType)}
                    removeReceivedRun={onRemoveReceivedRun}
                />
                <ReceivedRunModal
                    showModal={showModal}
                    closeModal={this.handleCloseRunModal}
                    confirmModal={this.handleConfirmRunModal}
                />
            </div>
        );
    }
}

ReceivedRun.propTypes = {
    onChooseReceivedRun: PropTypes.func,
    onRemoveReceivedRun: PropTypes.func,
};
ReceivedRun.defaultProps = {};

export default ReceivedRun;
